import axios from 'axios'
export const getInvoice = async (organizationId, programId, invoiceId) => {
    try {
        const response = await axios.get(
          `/organization/${organizationId}/program/${programId}/invoice/${invoiceId}`
        );
        // console.log(response)
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

// Both return { success } or { errors } where errors is always a string to show inline. The
// global error flash is suppressed for these calls so a refused action isn't reported twice.
export const HOLD_ACTION_REQUEST = { suppressErrorFlash: true };
const HOLD_ACTION_FALLBACK_ERROR = 'The action could not be completed.';

export const holdActionResult = (response) => {
    const data = response?.data || {};
    if (!response || response.status >= 400) {
        const { errors } = data;
        if (typeof errors === 'string') return { errors };
        const first = errors && typeof errors === 'object' ? Object.values(errors)?.[0]?.[0] : null;
        return { errors: (typeof first === 'string' && first) || data.message || HOLD_ACTION_FALLBACK_ERROR };
    }
    return data;
};

export const retryDepositHold = async (organizationId, programId, invoiceId, holdId) => {
    try {
        const response = await axios.put(
          `/organization/${organizationId}/program/${programId}/invoice/${invoiceId}/deposit-holds/${holdId}/retry`,
          null,
          HOLD_ACTION_REQUEST
        );
        return holdActionResult(response);
    } catch (e) {
        return holdActionResult(e?.response);
    }
};

export const cancelDepositHold = async (organizationId, programId, invoiceId, holdId, notes) => {
    try {
        const response = await axios.post(
          `/organization/${organizationId}/program/${programId}/invoice/${invoiceId}/reversepayment`,
          { deposit_hold_id: holdId, notes },
          HOLD_ACTION_REQUEST
        );
        return holdActionResult(response);
    } catch (e) {
        return holdActionResult(e?.response);
    }
};

// Program-scoped, not invoice-scoped: the API route approves a hold by its program alone.
export const approveDepositHold = async (organizationId, programId, holdId) => {
    try {
        const response = await axios.post(
          `/organization/${organizationId}/program/${programId}/deposit-holds/${holdId}/approve`,
          null,
          HOLD_ACTION_REQUEST
        );
        return holdActionResult(response);
    } catch (e) {
        return holdActionResult(e?.response);
    }
};

export const getPayInvoice = async (organizationId, programId, invoiceId) => {
    try {
        const response = await axios.get(
          `/organization/${organizationId}/program/${programId}/invoice/${invoiceId}/pay`
        );
        // console.log(response)
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

export const submitInvoicePayment = async (organizationId, programId, invoiceId, formData) => {
    try {
        const response = await axios.post(
          `/organization/${organizationId}/program/${programId}/invoice/${invoiceId}/pay`,
          formData
        );
        // console.log(response)
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};


export const getInvoicePreviewMonthToDate = async (organizationId, programId) => {
    try {
        const response = await axios.get(
          `/organization/${organizationId}/program/${programId}/invoice/preview/month-to-date`
        );
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

export const getInvoiceSummary = async (organizationId, programId, formData) => {
    try {
        const response = await axios.post(
          `/organization/${organizationId}/program/${programId}/invoice-summary`,
          formData
        );
        // console.log(response)
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

